"use strict";

exports.__esModule = true;
exports.TicketWatcherRuleListScreen = TicketWatcherRuleListScreen;
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _react = _interopRequireWildcard(require("react"));
var _polished = require("polished");
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _App = require("../../App");
var _API = require("../../API");
var _urls = require("../../../System/urls");
var _CreateTicketWatcherRuleScreen = require("../CreateTicketWatcherRuleScreen");
var _UpdateTicketWatcherRuleScreen = require("../UpdateTicketWatcherRuleScreen");
var _common = require("../../Device/common");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _TicketTypeListContext = require("../../TicketTypes/TicketTypeListContext");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var TagList = _styledComponents["default"].span.withConfig({
  displayName: "TicketWatcherRuleListScreen__TagList",
  componentId: "sc-ukuf61-0"
})([".", "{margin-top:0.5rem;margin-right:0.5rem;}"], _core.Classes.TAG);
function TicketWatcherRuleListScreen(_ref) {
  var history = _ref.history,
    id = _ref.match.params.id;
  var _useState = (0, _react.useState)(""),
    term = _useState[0],
    setTerm = _useState[1];
  var _useState2 = (0, _react.useState)(true),
    enabledFilter = _useState2[0],
    setEnabledFilter = _useState2[1];
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var filterPredicate = function filterPredicate(item) {
    return item.enabled === enabledFilter;
  };
  return /*#__PURE__*/_react["default"].createElement(_TicketTypeListContext.TicketTypeLoader, null, function (_ref2) {
    var fetchingTicketTypes = _ref2.fetching,
      ticketTypes = _ref2.data;
    if (fetchingTicketTypes || !ticketTypes) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    }
    return /*#__PURE__*/_react["default"].createElement(_API.Collection, {
      updateMethod: "PUT",
      baseURL: "/api/v1/ticketing/watcher-rule",
      itemBaseURL: "/api/v1/ticketing/watcher-rule/:id"
    }, function (collection) {
      return /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
        collection: collection,
        term: term,
        filterPredicate: filterPredicate
      }, function (_ref3) {
        var data = _ref3.data,
          reload = _ref3.reload;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !data && /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null), data && /*#__PURE__*/_react["default"].createElement(_Core.MasterDetailView, {
          selected: id,
          onSelect: function onSelect(selected) {
            if (selected === id || selected !== undefined) {
              return;
            }
            history.push((0, _urls.getScreenLocation)("TicketWatcherRuleList"));
          },
          renderMaster: function renderMaster() {
            return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
              "data-testid": "TicketWatcherRuleListScreen",
              title: translate("TicketWatcherRuleListScreen.title", "Ticket Watcher Rules")
            }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
              title: translate("TicketWatcherRuleListScreen.navbar.title", "Ticket Watcher Rules")
            }), /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, null, /*#__PURE__*/_react["default"].createElement(_Core.SearchInput, {
              value: term,
              onChange: setTerm
            }), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
              minimal: true,
              style: {
                marginLeft: "1rem"
              }
            }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
              type: "button",
              active: enabledFilter,
              text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
                id: "enabled",
                defaultMessage: "Enabled"
              }),
              onClick: function onClick() {
                return setEnabledFilter(true);
              }
            }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
              type: "button",
              active: !enabledFilter,
              text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
                id: "disabled",
                defaultMessage: "Disabled"
              }),
              onClick: function onClick() {
                return setEnabledFilter(false);
              }
            })), /*#__PURE__*/_react["default"].createElement(_Core.ToolbarDescription, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: "TicketWatcherRuleToolbar.count",
              defaultMessage: "\n                                      {value} {count, plural,\n                                        one {rule}\n                                        other {rules}\n                                      }\n                                    ",
              values: {
                value: /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
                  value: data.length
                })),
                count: data.length
              }
            }))), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
              style: {
                marginLeft: "auto"
              },
              intent: _core.Intent.PRIMARY,
              icon: _icons.IconNames.ADD,
              to: (0, _urls.getScreenLocation)("CreateTicketWatcherRule")
            }, translate("TicketWatcherRuleListScreen.createWatcherRuleButton.text", "Create Watcher Rule"))), /*#__PURE__*/_react["default"].createElement(_Core.ListView, null, data.map(function (item) {
              return /*#__PURE__*/_react["default"].createElement(_Core.ListItemView, {
                key: item.id
              }, /*#__PURE__*/_react["default"].createElement(_Core.ListItemViewLink, {
                to: (0, _urls.getScreenLocation)("UpdateTicketWatcherRule", {
                  id: item.id
                })
              }, /*#__PURE__*/_react["default"].createElement(_Core.ListItemHeading, {
                level: 4
              }, item.name), /*#__PURE__*/_react["default"].createElement(_Core.ListItemDescription, null, /*#__PURE__*/_react["default"].createElement("span", null, item.devices.map(function (obj) {
                if (obj.type === "UUID") {
                  var device = (0, _common.getDevice)(devices, obj.value);
                  return device ? device.name : obj.value;
                }
                return obj.value;
              }).join(", "))), /*#__PURE__*/_react["default"].createElement(TagList, null, item.types.map(function (typeId) {
                var ticketType = ticketTypes.find(function (type) {
                  return type.id === typeId;
                });
                if (!ticketType) return null;
                var backgroundColor = ticketType.color;
                var color = (0, _polished.readableColor)(backgroundColor);
                var style = {
                  color: color,
                  backgroundColor: backgroundColor
                };
                return /*#__PURE__*/_react["default"].createElement(_core.Tag, {
                  key: typeId,
                  style: style
                }, ticketType.value);
              }).filter(function (ticketType) {
                return ticketType != null;
              }))));
            })));
          },
          renderDetail: function renderDetail() {
            return /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.RootRoutes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
              path: (0, _urls.getScreenPath)("CreateTicketWatcherRule"),
              element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
                render: function render(props) {
                  return /*#__PURE__*/_react["default"].createElement(_CreateTicketWatcherRuleScreen.CreateTicketWatcherRuleScreen, _extends({}, props, {
                    collection: collection,
                    onSave: reload
                  }));
                }
              })
            }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
              path: (0, _urls.getScreenPath)("UpdateTicketWatcherRule"),
              element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
                render: function render(props) {
                  return /*#__PURE__*/_react["default"].createElement(_UpdateTicketWatcherRuleScreen.UpdateTicketWatcherRuleScreen, _extends({}, props, {
                    collection: collection,
                    onSave: reload,
                    onDelete: reload
                  }));
                }
              })
            }));
          }
        }));
      });
    });
  });
}